<script>
export default
{
    name: 'loading-dots',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        return (
            <div class='loading-dots'>
                <svg id='dots' width='132px' height='58px' viewBox='0 0 132 58' version='1.1' xmlns='http://www.w3.org/2000/svg'>
                    <g id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'>
                        <g class='dots'>
                            <circle id='dot1' cx='25' cy='30' r='13'></circle>
                            <circle id='dot2' cx='65' cy='30' r='13'></circle>
                            <circle id='dot3' cx='105' cy='30' r='13'></circle>
                        </g>
                    </g>
                </svg>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
        }
    },

    computed:
    {
    },

    methods:
    {
    },

    components:
    {
    }
}
</script>

<style lang='less'>
.loading-dots
{
    .dots
    {
        fill: #A3A3A3;

        #dot1
        {
            animation: load 1.5s infinite;
        }

        #dot2
        {
            animation: load 1.5s infinite;
            animation-delay: 0.2s;
        }

        #dot3
        {
            animation: load 1.5s infinite;
            animation-delay: 0.4s;
        }
    }

    @keyframes load
    {
        0%
        {
            opacity: 0;
        }
        50%
        {
            opacity: 1;
        }
        100%
        {
            opacity: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/LoadingDots.vue